import { MODIFY_CART_ERROR, MODIFY_CART_REQUEST, MODIFY_CART_SUCCESS } from '../types';
import { getOrLoadCart } from './get-or-load-cart';
import { useHelper } from '../helpers';
export const modifyCartRequest = props => {
  return {
    type: MODIFY_CART_REQUEST,
    data: props
  };
};
export const modifyCartSuccess = cart => {
  return {
    type: MODIFY_CART_SUCCESS,
    data: cart
  };
};
export const modifyCartError = function (error) {
  let meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: MODIFY_CART_ERROR,
    error: true,
    meta,
    payload: error
  };
};
export const modifyCart = options => {
  const {
    attributes
  } = options;
  return async (dispatch, getState, _ref) => {
    let {
      chord
    } = _ref;
    const {
      withCart
    } = useHelper(dispatch, getState);
    try {
      dispatch(modifyCartRequest(attributes));
      const {
        data: cart
      } = await getOrLoadCart(dispatch, getState);
      const input = {
        ...attributes,
        id: cart.id
      };
      const updatedCart = await withCart(chord.oms.updateOrder)(null, input);
      dispatch(modifyCartSuccess(updatedCart));
      return updatedCart;
    } catch (error) {
      dispatch(modifyCartError(error, attributes));
      throw error;
    }
  };
};